import {
  ProductPrice,
  flattenConnection,
  useProductOptions,
} from '@shopify/hydrogen';

import {useEffect, useState} from 'react';
import {Dialog} from '@headlessui/react';
import sanitizeHtml from 'sanitize-html';

import ProductOptions from './ProductOptions.client';
import {ProductImages} from './ProductImages';
import {ModalHeader} from './ModalHeader';
import {AddToCartMarkup} from './AddToCartMarkup';
import QuantitySelector from './QuantitySelector';
import Modal from '../Modal';
import classNames from 'classnames';
import {usePublicPageI18n} from '../../contexts/PublicPageI18n.client';
import {usePageContext} from '../../contexts/PageContext.client';
import {base64Decode} from 'shared/utils/base64';

export default function ProductModal({
  show,
  closeModal,
  product,
  title,
}: {
  show: boolean;
  closeModal: () => void;
  product: unknown;
  title: string;
}) {
  const {t} = usePublicPageI18n();
  const pageCtx = usePageContext();

  const {selectedVariant} = useProductOptions();
  // @ts-expect-error TODO: type definition for `product`
  const allImagesUrl = product.images?.edges?.map(
    // @ts-expect-error TODO: type definition for `product`
    (imageData: unknown) => imageData?.node?.transformedSrc,
  );
  // @ts-expect-error TODO: type definition for `product`
  const productImage = flattenConnection(product.images)[0]?.transformedSrc;
  const [selectedImage, setSelectedImage] = useState(productImage);
  const [quantity, setQuantity] = useState(1);
  const selectedVariantImageUrl = selectedVariant?.image?.url;

  useEffect(() => {
    setSelectedImage(selectedVariantImageUrl);
  }, [selectedVariantImageUrl]);

  return (
    <Modal show={show} closeModal={closeModal}>
      <div
        data-testid="product-popup"
        className={classNames(
          'inline-block',
          'w-full',
          'transform',
          'bg-white',
          'text-left',
          'align-bottom',
          'shadow-xl',
          'transition-all',
          'md:my-8',
          'md:max-w-[40rem]',
          'md:rounded-2xl',
          'md:align-middle',
        )}
      >
        <div className="divide-y">
          <ModalHeader title={title} closeModal={closeModal} />
          <div
            className={classNames(
              'max-h-modal',
              'gap-8',
              'overflow-auto',
              'p-6',
              'md:grid',
              'md:grid-cols-2',
            )}
          >
            {selectedImage && (
              <ProductImages
                selectedImage={selectedImage}
                allImagesUrl={allImagesUrl}
                setSelectedImage={setSelectedImage}
              />
            )}
            <div>
              <Dialog.Title
                as="h3"
                className={classNames(
                  'text-2xl',
                  'font-medium',
                  'leading-8',
                  'text-gray-900',
                )}
              >
                {/* @ts-expect-error TODO: type definition for `product` */}
                {product.title}
              </Dialog.Title>

              <div className={classNames('mt-2', 'flex', 'flex-col')}>
                <ProductPrice
                  // @ts-expect-error TODO: fix typing for Product
                  data={product}
                  className="text-xl"
                  priceType="regular"
                  variantId={base64Decode(selectedVariant?.id || '')}
                />
                {pageCtx.slug !== 'linkpoptruck' && (
                  <>
                    <p className={classNames('text-sm', 'font-light')}>
                      {t('quantity')}
                    </p>
                    <div className="flex">
                      <QuantitySelector
                        quantity={quantity}
                        setQuantity={setQuantity}
                      />
                    </div>
                  </>
                )}
              </div>
              <div className="mt-2">
                <ProductOptions />
              </div>
              <div className="mt-4">
                <AddToCartMarkup
                  product={product}
                  closeModal={closeModal}
                  quantity={quantity}
                />
              </div>

              <div>
                <div
                  className={classNames(
                    'prose',
                    'mt-2',
                    'border-t',
                    'border-gray-200',
                    'pt-6',
                    'text-sm',
                    'text-black',
                  )}
                  dangerouslySetInnerHTML={{
                    // @ts-expect-error TODO: type definition for `product`
                    __html: sanitizeHtml(product.descriptionHtml),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
